const styles = (theme) => ({
  card: {
    border: `1px solid ${theme.color.grey_d3}`,
    borderRadius: 5,
  },
  homePageWidget: {
    border: `1px solid ${theme.color.grey_d3}`,
    borderRadius: 10,
    marginBottom: theme.spacing(2),
  },
  headerTitle: {
    textTransform: 'capitalize',
  },
  headerLink: {
    alignSelf: 'start',
    marginTop: 0,
  },
  homePageWidgetHeader: {
    padding: theme.spacing(1.5, 2),
    borderBottom: 'none',
  },
  widgetActionButton: {
    color: theme.color.teal,
    textTransform: 'capitalize',
    fontSize: 16,
    lineHeight: 1.5,
  },
  widgetActionIcon: {
    '& .MuiButton-endIcon': {
      marginLeft: 0,
    },

    '& svg': {
      fill: theme.color.teal,
    },
  },
  isButton: {
    padding: theme.spacing(2.5, 2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
});

export default styles;
